export default "__VITE_ASSET__C4H3yXWo__"